module.exports = __webpack_public_path__ + "assets/img/Sync.4f1261da.svg";